export const WITHHOLD_OPTIONS_LABEL_ENUM = {
  ALL: 'ALL',
  OFF: 'Withhold OFF',
  ON: 'Withhold ON',
}

export const WITHHOLD_OPTIONS_VALUE_ENUM = {
  ALL: 'ALL',
  OFF: 'OFF',
  ON: 'ON',
}

export const withholdPayOptions = [
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.ALL,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.ALL,
  },
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.OFF,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.OFF,
  },
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.ON,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.ON,
  },
]



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/options.js